import { Suspense, lazy } from 'react'
import { MascotErrorBoundary } from '@/features/assistant/components/mascot/mascot-error-boundary'
import { MascotPoster } from '@/features/assistant/components/mascot/mascot-poster'

// Lazy load the 3D loader to reduce initial bundle size
const Loader3D = lazy(() =>
  import('@/components/loader-3d').then((mod) => ({ default: mod.Loader3D }))
)

/**
 * The router's pending screen for route transitions, shown to every web user.
 *
 * If the loader's lazy chunk fails to load (a tab left open across a deploy asks for a hashed
 * file that is gone), the `thinking` poster and the caption show instead and the route still
 * renders. The poster lives at a path that survives a deploy.
 */
export function RoutePending(): React.JSX.Element {
  return (
    <div className='flex h-screen w-full items-center justify-center'>
      <MascotErrorBoundary
        fallback={
          <div className='flex flex-col items-center justify-center'>
            <div className='h-64 w-64' aria-hidden='true'>
              <MascotPoster emotion='thinking' />
            </div>
            <p className='text-muted-foreground mt-4 text-sm font-medium'>
              Loading...
            </p>
          </div>
        }
      >
        <Suspense
          fallback={
            <div className='text-muted-foreground animate-pulse'>
              Loading...
            </div>
          }
        >
          <Loader3D size='lg' text='Loading...' />
        </Suspense>
      </MascotErrorBoundary>
    </div>
  )
}
